import styled, { css } from "styled-components"
import media from "src/styles/media"
import BackgroundImage from "gatsby-background-image"
import Img from "gatsby-image"

export const PageHeaderWrapper = styled(BackgroundImage)`
    position: relative;
    height: 600px;
    background-size: cover;
    width: 100%;
    overflow: hidden;

    ${media.lessThan("md")`
        height: 500px;
    `}

    ${props =>
      props.size === "sm" &&
      css`
        height: 450px;
        padding-top: 60px;

        ${media.lessThan("md")`
            padding-top: 70px;
            height: 320px;
        `}
      `}

    ${props =>
      props.customBg &&
      css`
        .custom-bg-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: url(${props.customBg}) !important;
          background-size: cover;
          background-attachment: fixed;
          z-index: 1;
          filter: blur(10px);

          &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: var(--dark);
            opacity: 0.7;
          }
        }
      `}
`

export const PageHeaderContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  z-index: 2;
`

export const PageHeaderTitle = styled.h1`
  font-size: 57px;
  font-weight: 600;
  max-width: 500px;
  line-height: 1.2;
  text-align: center;
  font-weight: normal;

  ${media.lessThan("md")`
        font-size: 38px;
    `}

  ${props =>
    props.size === "sm" &&
    `
        font-size: 50px;
        max-width: 650px;

        ${media.lessThan("md")`
            font-size: 32px;
        `}
    `}
`

export const PageHeaderSubTitle = styled.h2`
  font-size: 32px;
  font-weight: 300;
  max-width: 500px;
  line-height: 1.2;
  text-align: center;
  font-weight: normal;

  ${media.lessThan("md")`
        font-size: 27px;
    `}
`

export const PageHeaderTag = styled.h4`
  font-size: 17px;
  font-weight: 400;
  max-width: 500px;
  line-height: 1.2;
  text-align: center;
  font-weight: normal;
  border: 1.2px solid var(--primary);
  border-radius: 35px;
  padding: 7px 24px;
  text-transform: uppercase;

  ${media.lessThan("md")`
        font-size: 16px;
    `}

  ${media.lessThan("sm")`
        font-size: 14px;
    `}
`

export const PageHeaderCurveBottom = styled(Img)`
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  transform: translateY(-100%);
  z-index: 3;
`
